import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGalleryData } from '../../features/Gallery/Gallery';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import './style.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SeeMore } from '../../Buttons/Buttons';

function GalleryPage() {
    const dispatch = useDispatch();
    const {i18n,t}=useTranslation()
    useEffect(() => {
        dispatch(fetchGalleryData(8));
    }, [dispatch,i18n.language]);

    const { galleries } = useSelector((state) => state.gallery);
    return (
        <div className=" px-4 bg-gradient-to-br py-10 from-gray-900 via-slate-900 to-green-900 overflow-hidden">


            <h1 className="text-4xl font-bold  pt-5 text-center  bg-gradient-to-r from-blue-400 to-green-400 bg-clip-text text-transparent">
                {t("gallery")}
            </h1>
            <Swiper
            key={i18n.language}
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={'auto'}
                coverflowEffect={{
                    rotate: 10,
                    stretch: 0,
                    depth: 200,
                    modifier: 1,
                    slideShadows: true,
                }}
           
                modules={[EffectCoverflow, Navigation]}
                className="layered-swiper"
            >
                {galleries?.length > 0 ? (
                    galleries.map((gallery, index) => (
                        <SwiperSlide key={index} className="group">
                            <div className="relative h-[400px] transform transition-transform duration-500 group-hover:scale-105">
                                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-black/20 rounded-2xl" />
                                <img
                                    src={`${process.env.REACT_APP_IMG_URL}${gallery.image}`}
                                    alt={`Gallery ${index + 1}`}
                                    className="w-full h-full object-cover rounded-2xl shadow-2xl"
                                    loading="lazy"
                                />
                                {/* <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
                                    <h3 className="text-lg font-medium text-white">
                                        {gallery.title || `Collection ${index + 1}`}
                                    </h3>
                                </div> */}
                            </div>
                        </SwiperSlide>
                    ))
                ) : (
                    <SwiperSlide className="flex items-center justify-center text-gray-400">
                        <div className="text-center">
                            <p className="text-xl">No images available</p>
                        </div>
                    </SwiperSlide>
                )}

                {/* Navigation Arrows */}
            
            </Swiper>
            <div className="flex justify-center ">

            <SeeMore link={"/gallery"}/>    
            </div>
            
        </div>
    );
}

export default GalleryPage;